var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / close"),React.createElement("g",{"id":"icons-/-close","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"close","fill":"currentColor","points":"20 2 11.707 10.293 3.414 2 2 3.414 10.293 11.706 2 20 3.414 21.414 11.707 13.121 20 21.414 21.414 20 13.121 11.706 21.414 3.414"}))]);
}

Close.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Close;

Close.default = Close;
